import { HealthcareService } from "fhir/r5";
import { loadAllResources, loadResource } from "./FhirBundleService";

// Search parameters
const HEALTHCARE_SERVICE_SEARCH_PARAMS = {
  _count: "200",
  _elements: "id,name,identifier,providedBy,location,active,offeredIn,extension",
  _sort: "name",
};

const INTERNAL_HEALTHCARE_SERVICE_SEARCH_PARAMS = {
  ...HEALTHCARE_SERVICE_SEARCH_PARAMS,
  _tag: "internal",
};

// Resource loaders
async function loadHealthcareService(
  healthcareServiceId: string
): Promise<HealthcareService> {
  return loadResource<HealthcareService>(
    "HealthcareService",
    healthcareServiceId ?? ""
  );
}

async function loadAllHealthcareServices(): Promise<HealthcareService[]> {
  return loadAllResources<HealthcareService>(
    "HealthcareService",
    HEALTHCARE_SERVICE_SEARCH_PARAMS
  );
}

async function loadAllInternalHealthcareServices(): Promise<HealthcareService[]> {
  return loadAllResources<HealthcareService>(
    "HealthcareService",
    INTERNAL_HEALTHCARE_SERVICE_SEARCH_PARAMS
  );
}

// Exports
const HealthcareServiceService = {
  loadHealthcareService,
  loadAllHealthcareServices,
  loadAllInternalHealthcareServices,
};

export default HealthcareServiceService;
